import { createReducer } from 'redux-act';
import {requestGetAdminUser, responseGetAdminUser,  requestAddUpdateAdminUser, responseAddUpdateAdminUser} from './action';



const defaultState = {
	requestProcess: false,
};

const reducer = createReducer({

	[requestGetAdminUser]: (state) => {
		return {
			requestProcess: true,
			data: [],
		};
	},

	[responseGetAdminUser]: (state, params) => {
		return {
			requestProcess: false,
			data: params,
		};
	},

	[requestAddUpdateAdminUser]: (state) => {
		return {
			requestProcess: true,
			addUpdateData: [],
		};
	},

	[responseAddUpdateAdminUser]: (state, params) => {
		return {
			requestProcess: false,
			addUpdateData: params,
		};
	}


}, defaultState);



export default reducer
